export const sxStyled = theme => ({
  dGrid: {
    fontFamily: "'Open Sans', sans-serif",
  },

  boxContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    p: '20px',
    bgcolor: theme.headerColor,
    flexDirection: { xs: 'column', sm: 'row' },
  },

  dFlex: {
    display: 'flex',
    flexWrap: 'wrap',
    width: { xs: '100%', lg: '30%' },
    flexDirection: { xs: 'row', lg: 'row' },
    justifyContent: { xs: 'flex-start', sm: 'space-between' },
  },

  cardBox: {
    border: 'solid 2px #D1D1D1',
    mx: '10px',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: { xs: '100%', sm: '140px' },
    maxWidth: '300px',
    height: '140px',
    cursor: 'pointer',
    '&:hover': {
      bgcolor: '#D1D1D1',
    },
  },

  cardText: {
    fontSize: '18px',
    lineHeight: '25px',
    textAlign: 'center',
    color: '#545454',
    pt: '6px',
  },

  cardTitle: {
    fontSize: '18px',
    color: '#545454',
    mb: '5px',
    ml: '10px',
  },

  parrafo: {
    fontSize: '16px',
    my: '8px',
  },

  icon: {
    fontSize: '52px',
  },

  buttonCard: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    py: '20px',
    borderRadius: 0,
    borderBottom: '1px solid #ddd',
  },

  label: {
    textTransform: 'initial',
  },

  gridText: {
    display: 'grid',
    textTransform: 'initial',
    textAlignLast: 'justify',
  },

  btnAceptar: {
    bgcolor: 'rgb(194, 230, 250)',
    p: '5px 15px',
    textTransform: 'uppercase',
  },

  text: {
    fontSize: '16px',
    mb: '10px',
  },

  titleNot: {
    fontSize: '20px',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 400,
    alignItems: 'center',
    my: '10px',
  },
});
